var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-list",
    [
      _vm.showSearch
        ? _c("v-text-field", {
            staticClass: "py-1 chat-search",
            attrs: {
              loading: _vm.searchLoading,
              label: "Search Messages",
              "append-icon": "search",
              outlined: "",
              rounded: "",
              dense: "",
              "hide-details": "",
              clearable: "",
              autofocus: !!_vm.searching,
            },
            on: {
              input: function ($event) {
                return _vm.setSearchTimer()
              },
              "click:clear": function ($event) {
                _vm.search = ""
              },
            },
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showLoading
        ? _c(
            "v-list",
            { staticClass: "w-full" },
            [
              _c("v-skeleton-loader", {
                staticClass: "w-full",
                attrs: { type: "list-item-avatar-three-line@6" },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.showLoading
        ? _c(
            "v-list-item-group",
            {
              ref: "conversationList",
              staticClass: "py-4",
              class: {
                "conversation-scroll":
                  _vm.$vuetify.breakpoint.mdAndUp &&
                  _vm.allConversations.length,
              },
              attrs: { value: _vm.value?.id ?? null },
            },
            [
              !_vm.allConversations.length
                ? _c(
                    "v-list-item",
                    { staticClass: "px-6" },
                    [
                      _c("v-list-item-title", { staticClass: "soli-grey" }, [
                        _vm._v("No Conversations Found"),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showViewLatest
                ? _c(
                    "div",
                    {
                      staticClass:
                        "flex shrink items-center w-full justify-center mb-4 sticky z-10 top-0",
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", rounded: "", color: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.viewLatest()
                            },
                          },
                        },
                        [_vm._v("View Latest")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.allConversations, function (item) {
                return _c(
                  "v-list-item",
                  {
                    key: item.id,
                    staticClass: "soli-round conversation-items",
                    attrs: {
                      id: `conversation-${item.id}`,
                      value: item.id,
                      "three-line": "",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.handleSelect(item)
                      },
                    },
                  },
                  [
                    _c("ConversationPreview", {
                      attrs: { item: item, selected: item.id == _vm.value?.id },
                    }),
                    _vm._v(" "),
                    _c(
                      "v-menu",
                      {
                        attrs: { "offset-y": "", left: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function ({ on }) {
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      {
                                        attrs: {
                                          small: "",
                                          icon: "",
                                          color: "dark",
                                        },
                                      },
                                      on
                                    ),
                                    [
                                      _c("v-icon", { attrs: { small: "" } }, [
                                        _vm._v("more_vert"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _vm._v(" "),
                        _c(
                          "v-list",
                          [
                            _c(
                              "v-list-item",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.markUnread({
                                      conversation: item,
                                    })
                                  },
                                },
                              },
                              [_vm._v("Mark Unread\n                    ")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _vm.previousLoading
                ? _c(
                    "v-list-item",
                    { attrs: { "three-line": "" } },
                    [
                      _c("v-skeleton-loader", {
                        staticClass: "w-full",
                        attrs: { type: "list-item-avatar-three-line" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", {
                directives: [
                  {
                    name: "intersect",
                    rawName: "v-intersect",
                    value: {
                      root: ".conversation-scroll",
                      handler: _vm.bottomVisible,
                      options: { rootMargin: "100px", threshold: 0 },
                    },
                    expression:
                      "{\n                root: '.conversation-scroll',\n                handler: bottomVisible,\n                options: { rootMargin: '100px', threshold: 0 },\n            }",
                  },
                ],
                attrs: { id: "bottom-anchor" },
              }),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }